// Коды тарифов школы (accounts.tariff), приходят в GET /api/get-user-info → tariff.id
export const enum TARIFF {
    test = 1,          // Тестовый — импорт доступен
    paid = 2,          // Оплаченный — импорт доступен
    preferential = 4,  // Льготный — импорт НЕ доступен
    needPayment = 5,   // Требуется оплата
}

/**
 * Импорт недоступен на льготном тарифе (id === 4).
 * Для superadmin и пользователя без школы tariff.id приходит как null —
 * трактуем как «без ограничений», импорт доступен.
 */
export const isImportBlockedByTariff = (tariffId?: number | null): boolean =>
    tariffId === TARIFF.preferential;
